import React from 'react';

import { NotifCheckboxReasonStep } from './NotifCheckboxReasonStep';

export const ReasonStep = (props) => {
  return <NotifCheckboxReasonStep {...props} noCheckbox />;
};
